<app-nav></app-nav>
<section class="intimate" *ngIf="!intimateSuccessfull && !intimateFailure">
    <div class="container">
        <div class="col">
            <form #formClaimIntimate="ngForm">
                <center class="sub-title mt-4">
                    <p>Health Insurance</p>
                </center>
                <div class="col sum-container">
                    <p class="title mendate">Type of Policy</p>
                    <div class="sum-insured-input">
                        <div class="form-check-inline">
                            <label class="form-check-label">
                                <input type="radio" class="form-check-input" name="typeOptions"
                                    [(ngModel)]="typeOptions" (change)="getGroupInsurancePolicyDetails()"><label>Group
                                    Health</label>
                            </label>
                        </div>
                        <!-- <div class="form-check-inline">
                            <label class="form-check-label">
                                <input type="radio" class="form-check-input" name="typeOptions"
                                    [(ngModel)]="typeOptions" [value]="true" (change)="getIndividualInsurancePolicyDetails()" [checked]="typeOptions"
                                    ><label>Individual Health</label>
                            </label>
                        </div> -->
                    </div>
                    <div *ngIf="!noDataFound">
                        <p class="title mt-4 mendate">Insurer</p>
                        <div class="sum-insured-input">
                            <div class="form-group">
                                <select class="form-control" name="insurer" id="insurer"
                                    [(ngModel)]="selectedInsurerName" #insurerList="ngModel" (change)="getInsurerData($event.target.selectedIndex)" required>
                                    <option disabled selected value="">Select Insurer</option>
                                    <option value="{{insurerName}}" *ngFor="let insurerName of insurer; let i = index">{{insurerName | uppercase}}
                                    </option>
                                </select>
                                <!-- <div *ngIf="insurerList.invalid && insurerList.touched " class="error-message">
                                    <div *ngIf="insurerList.errors.required">
                                        Insurer is required.
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <p class="title mt-4 mendate">Policy Number</p>
                        <div class="sum-insured-input">
                            <div class="form-group">
                                <select class="form-control" name="policyNumber" id="policyNumber"
                                    [(ngModel)]="selectedPolicyNumber" #policyNumberList="ngModel" (change)="getPolicyNumberData()" required disabled>
                                    <option disabled selected value="">Select Policy Number</option>
                                    <option value="{{policy}}" name="policy" *ngFor="let policy of policyNumber">
                                        {{policy}}</option>
                                </select>
                                <!-- <div *ngIf="policyNumberList.invalid && policyNumberList.touched " class="error-message">
                                    <div *ngIf="policyNumberList.errors.required">
                                        Policy Number is required.
                                    </div>
                                </div> -->
                            </div>
                        </div>

                        <p class="title mt-4 mendate">Patient Name</p>
                        <div class="sum-insured-input">
                            <div class="form-group">
                                <div class="sum-insured-input">
                                    <div class="form-group" *ngIf="!individualInsuranceClaimant">
                                        <select class="form-control" name="claimant" id="claimant"
                                            [(ngModel)]="selectedClaimantName" (change)="getCardNumberData(selectedClaimantName)" required disabled>
                                            <option disabled selected value="">Select Patient Name</option>
                                            <option [ngValue]="name" *ngFor="let name of claimantName">{{name.name | uppercase}}</option>
                                        </select>
                                    </div>
                                    <div class="form-group" *ngIf="individualInsuranceClaimant">
                                        <input class="form-control" name="claimant" id="claimant" [(ngModel)]="claimant"
                                            value="{{claimantName}}" disabled required>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p class="title mt-4 mendate">Relation with Claimant</p>
                        <div class="sum-insured-input">
                            <div class="form-group">
                                <input type="text" name="relation" class="form-control" [(ngModel)]="selectedRelation"
                                 #relation="ngModel" value={{selectedRelation}} disabled>
                                <!-- <select class="form-control" name="relation" id="relation"
                                    [(ngModel)]="selectedRelation" #relation="ngModel" required>
                                    <option disabled selected value="">Select Relation</option>
                                    <option [ngValue]="relationName" *ngFor="let relationName of relations">{{relationName}}</option>
                                </select>
                                <div *ngIf="relation.invalid && relation.touched " class="error-message">
                                    <div *ngIf="relation.errors.required">
                                        Relation is required.
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <p class="title mt-4 mendate">Treatment for</p>
                        <div class="sum-insured-input">
                            <div class="form-group">
                                <input type="text" class="form-control city-input" [typeahead]="diseaseList" (typeaheadOnSelect)="selectTreatment($event)" (focusout)="checkTreatmentValue($event)"
                                [isAnimated]="true" #ailment="ngModel" name="ailment" [(ngModel)]="intimate.ailment" autocomplete="off"
                                maxlength="50" required />
                                <!-- <input type="text" name="ailment" class="form-control"  (typeaheadOnSelect)="selectCity($event)" (focusout)="checkCityValue($event)"
                                    [(ngModel)]="formClaimIntimate.ailment" #ailment="ngModel" required> -->
                                <div class="">
                                    <!-- <div *ngIf="ailment.invalid && ailment.touched " class="error-message">
                                        <div *ngIf="ailment.errors.required">
                                        Field is required.
                                        </div>
                                    </div> -->
                                    <!-- <div *ngIf="noResult" class="error-message">No results found!</div> -->
                                </div>
                            </div>
                        </div>

                        <div class="" *ngIf = "intimate.ailment==='Maternity/Pregnancy/Delivery'">
                            <p class="title mt-4 ">Baby's Name</p>
                            <div class="sum-insured-input">
                                <div class="form-group">
                                    <input type="text" name="babyName" class="form-control" value="{{babyName}}"
                                        [(ngModel)]="babyName"  >
                                </div>
                     
                            </div>
                        </div>
                   
                    
                    <div class="" *ngIf = "intimate.ailment==='Maternity/Pregnancy/Delivery'">
                        <p class="title mt-4 ">Baby's DOB</p>
                        <div class="sum-insured-input reg-date-input proposal-date-input">
                            <div class="input-group">
                                <div class="input-group addon">
                                    <img
                                        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                                    <p-calendar [touchUI]="true" [readonlyInput]="true" placeholder=""
                                        name="babyDob" [(ngModel)]="babyDob" keepInvalid
                                        [maxDate]="dateTime"
                                        dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                                        yearRange="1900:2100" required></p-calendar>
                                        
                                    <span class="input-group-addon" id="basic-addon-dueDate"></span>
                                </div>
                            </div>
                        </div>   
                    </div>
               
                <div class="" *ngIf = "intimate.ailment==='Maternity/Pregnancy/Delivery'">
                    <p class="title mt-4 ">Baby's Gender</p>
                    <div class="sum-insured-input">
    
                        <select class="form-control" name="babyGender" id="babyGender"
                        [(ngModel)]="babyGender" #insurerList="ngModel">
                        <option disabled selected value="">Select Gender</option>
                        <option value="Male" >Male</option>
                        <option value="Female" >Female</option>
                    </select>
    
                    </div>
                </div>
 
            <div class="" *ngIf = "intimate.ailment==='Maternity/Pregnancy/Delivery'">
                <p class="title mt-4 ">Employee Code</p>
                <div class="sum-insured-input">
                    <div class="form-group" *ngIf="!individualInsuranceClaimant">
                        <input type="text" name="employeeCode" class="form-control" value="{{employeeCode}}"
                            [(ngModel)]="employeeCode"  >
                    </div>
                </div>
            </div>
      
                        <p class="title mt-4 mendate">E-mail</p>
                        <div class="sum-insured-input">
                            <div class="form-group">
                                <input type="email" name="email" id="email" class="form-control" [(ngModel)]="intimate.email"
                                [email]="true" #email="ngModel" maxlength="200" value="{{intimate.email}}" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$" [disabled]=isEmailAvailable required>
                                <!-- <div *ngIf="email.invalid && email.touched " class="error-message">
                                    <div *ngIf="email.errors.required">
                                        Email Address is required.
                                    </div>
                                    <div *ngIf="email.errors.pattern">
                                        Please enter the valid e-mail id
                                    </div>
                                </div> -->
                            </div>
                        </div>
                      
              
                        <p class="title mt-4 mendate">Mobile no.</p>
                        <div class="sum-insured-input">
                            <div class="form-group">
                                <input type="text" class="form-control" name="mobile"
                                    [(ngModel)]="mobileNumber" #mobile="ngModel" minlength="10"
                                    maxlength="10" pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric"  [disabled]=isMobileAvailable required />
                                <!-- <div *ngIf="mobile.invalid && mobile.touched" class="error-message">
                                    <div *ngIf="mobile.errors.required">
                                        Mobile number is required.
                                    </div>
                                    <div *ngIf="mobile.errors.maxlength">
                                        Mobile number should not be greater than 10 digits.
                                    </div>
                                    <div *ngIf="mobile.errors.minlength || !mobile.errors.pattern && !mobile.errors.required">
                                        Mobile number must be at least 10 digits long.
                                    </div>
                                    <div *ngIf="mobile.errors.pattern && !mobile.errors.minlength && !mobile.errors.required">
                                        Invalid mobile number.
                                    </div> -->
                                </div>
                            </div>

                            <div class="" *ngIf = "isInsurerIcici">
                                <p class="title mt-4 mendate">Date Of Birth</p>
                                <div class="sum-insured-input reg-date-input proposal-date-input">
                                    <div class="input-group">
                                        <div class="input-group addon">
                                            <img
                                                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                                            <p-calendar [touchUI]="true" [readonlyInput]="true" placeholder="Date Of Birth"
                                                name="dateOfBirth" [(ngModel)]="dateOfBirth" keepInvalid
                                                [maxDate]="dateTime"
                                                dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                                                yearRange="1900:2100" required></p-calendar>
                                             </div>
                                    </div>
                                </div>   
                            </div>
                            
                        </div>
                        <div class="row">
                            <!-- <div class="col">
                                <p class="title mt-4 mendate">Date of Birth</p>
                                <div class="sum-insured-input reg-date-input proposal-date-input">
                                    <div class="input-group">
                                        <div class="input-group addon">
                                            <img
                                                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                                            <p-calendar [touchUI]="true" [readonlyInput]="true" placeholder="Date"
                                                name="dob" [(ngModel)]="dob" keepInvalid [required]="true"
                                                dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                                                yearRange="1900:2100" [maxDate]="adminssionMaxDate" (onClose)="checkDatevalue()"></p-calendar>
                                            <span class="input-group-addon" id="basic-addon-dueDate"></span>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="DOBrequired" class="error-message">
                                    Date of Birth is required.
                                </div>
                            </div> -->
                            <div class="col">
                                <p class="title mt-4 mendate">Card no.</p>
                                <div class="sum-insured-input">
                                    <div class="form-group" *ngIf="!individualInsuranceClaimant">
                                        <input type="text" name="cardNumber" class="form-control" value="{{cardNumber}}"
                                            [(ngModel)]="cardNumber" disabled required>
                                    </div>
                                    <div class="form-group" *ngIf="individualInsuranceClaimant">
                                        <input type="number" name="cardNumber" class="form-control" [(ngModel)]="cardNumber"
                                            value="" required>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col"> -->
                                <p class="title mt-4 mendate">Admission Date</p>
                                <div class="sum-insured-input reg-date-input proposal-date-input">
                                    <div class="input-group">
                                        <div class="input-group addon">
                                            <img
                                                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                                            <p-calendar [touchUI]="true" [readonlyInput]="true" placeholder="Date"
                                                name="regDate" [(ngModel)]="regDate" keepInvalid
                                                dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                                                yearRange="1900:2100" required></p-calendar>
                                            <span class="input-group-addon" id="basic-addon-dueDate"></span>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div *ngIf="AddmissionDateRequired" class="error-message">
                                    Admission Date is required.
                                </div> -->
                            <!-- </div>
                            <div class="col"> -->
                                <p class="title mt-4 mendate">Estimated Amount</p>
                                <div class="sum-insured-input">
                                    <div class="form-group">
                                        <input type="text" name="estimatedAmount" class="form-control"
                                            [(ngModel)]="intimate.estimatedAmount" #estimatedAmount="ngModel" maxlength="9" pattern="^[0-9]*$" inputmode="numeric" required>
                                        <!-- <div *ngIf="estimatedAmount.invalid && estimatedAmount.touched " class="error-message">
                                            <div *ngIf="estimatedAmount.errors.required">
                                                Claim Amount is required.
                                            </div>
                                            <div *ngIf="estimatedAmount.errors.pattern">
                                                Please enter valid amount.
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            <!-- </div> -->
                        <!-- </div> -->
                        <!-- <p class="title mt-4 mendate">Emergency Contact Name</p>
                        <div class="sum-insured-input">
                            <div class="form-group">
                                <input type="text" name="emergencyContactName" class="form-control"
                                    [(ngModel)]="intimate.emergencyContactName" #emergencyContactName="ngModel" required>
                                <div *ngIf="emergencyContactName.invalid && emergencyContactName.touched " class="error-message">
                                    <div *ngIf="emergencyContactName.errors.required">
                                        Claim Amount is required.
                                    </div>
                                    <div *ngIf="emergencyContactName.errors.pattern">
                                        Please enter valid amount.
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <!-- <p class="title mt-4 mendate">Hospital Pincode</p>
                        <div class="sum-insured-input">
                            <div class="form-group">
                                <input type="number" name="hospitalPincode" [(ngModel)]="intimate.hospitalPincode" #hospitalPincode="ngModel" class="form-control"
                                 maxlength="6" required>
                                <div *ngIf="hospitalPincode.invalid && hospitalPincode.touched " class="error-message">
                                    <div *ngIf="hospitalPincode.errors.required">
                                        Hospital Pincode is required.
                                    </div>
                                    <div *ngIf="hospitalPincode.errors.pattern">
                                        Please enter valid Hospital Pincode.
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <p class="title mt-4 mendate" *ngIf="careDropDown">Hospital Zone</p>
                        <div class="sum-insured-input">
                            <div class="form-group">
                                <div *ngIf="careDropDown">
                                <ng-multiselect-dropdown
                                [placeholder]="'Select Hospital Zone'"
                                [settings]="dropdownSettings"
                                [data]="dropdownListHospitalZone"
                                (onSelect)="onSelectHospitalZone($event)"
                                name="zone"
                               
                                >
                            </ng-multiselect-dropdown>
                        </div>
                            </div>
                        </div>
                        <p class="title mt-4 mendate">Hospital State</p>
                        <div class="sum-insured-input">
                            <div class="form-group">
                                <div>
                                <input type="search" name="hospitalState" [(ngModel)]="intimate.hospitalState" #hospitalState="ngModel" class="form-control"
                                pattern="[a-zA-Z\s]+" maxlength="200"  (input)="handleStateSearch($event)" (click)="openDropState()" required auto-close="outsideClick" >
                               </div>
                                <div *ngIf="careDropDown && openStateDropdown" class="dropDownEclaims" >
                                <div   *ngFor="let detail of dropdownList;  let i = index">
                                    <p (click)="onSelectState(detail)">{{detail.item_text}}</p>
                                </div>
                                <div *ngIf="dropdownList.length===0">No Data</div>
                            </div>
                                
                            </div>
                        </div>
                        
                        
                        <p class="title mt-4 mendate" *ngIf="careDropDown">Hospital District</p>
                        <div class="sum-insured-input">
                            <div class="sum-insured-input" *ngIf="careDropDown">
                                    <input type="text" name="district" class="form-control" value="{{district}}"
                                        [(ngModel)]="district" required>
                            </div>
                        </div>

                        <p class="title mt-4 mendate">Hospital City</p>
                        <div class="sum-insured-input">
                            <div class="form-group">
                                <div>
                                <input   type="text" name="hopitalCity" [(ngModel)]="intimate.hospitalCity" #hospitalCity="ngModel" class="form-control"
                                pattern="[a-zA-Z\s]+" maxlength="50" (input)="handleCitySearch($event)" (click)="openDropCity()" required auto-close="outsideClick" required>
                                </div>
                        <div *ngIf="careDropDown && openCityDropdown" class="dropDownEclaims">
                            <div   *ngFor="let detail of dropdownListCity;  let i = index">
                                <p (click)="onSelectCity(detail)">{{detail.item_text}}</p>
                            </div>
                            <div *ngIf="dropdownListCity.length===0">No Data</div>
                        </div>
                            </div>
                        </div>
                        <p class="title mt-4 mendate">Hospital Name</p>
                        <div class="sum-insured-input">
                            <div class="form-group">
                                    
                                <div>
                                <input  type="text" name="hospitalName" [(ngModel)]="intimate.hospitalName" #hospitalName="ngModel" class="form-control"
                                pattern="[a-zA-Z\s]+" maxlength="200"  (input)="handleHospitalNameSearch($event)" (click)="openDropHospitalName()" required auto-close="outsideClick" required>
                                </div>
                        <div *ngIf="careDropDown && openHospitalNameDropdown" class="dropDownEclaims">
                            <div   *ngFor="let detail of dropdownListHospitalName;  let i = index">
                                <p (click)="onSelectHospitalName(detail)">{{detail.item_text}}</p>
                            </div>
                            <div *ngIf="dropdownListHospitalName.length===0">No Data</div>
                        </div>
                            </div>
                        </div>
                        
                        <p class="title mt-4 mendate" *ngIf="careDropDown || isInsurerIcici">Hospital Address</p>
                        <div class="sum-insured-input">
                            <div class="sum-insured-input" *ngIf="careDropDown || isInsurerIcici">
                                <input  type="text" name="hospitalAddress" [(ngModel)]="intimate.hospitalAddress" #hospitalAddress="ngModel" class="form-control"
                                pattern="[a-zA-Z\s]+" maxlength="200"  required>
                            </div>
                        </div>
                        <p class="title mt-4 mendate" *ngIf="careDropDown || isInsurerIcici">Hospital Pincode</p>
                        <div class="sum-insured-input">
                            <div class="sum-insured-input" *ngIf="careDropDown || isInsurerIcici">
                                <input  type="text" name="hospitalPincode" [(ngModel)]="intimate.hospitalPincode" #hospitalPincode="ngModel" class="form-control"
                                pattern="[a-zA-Z\s]+" maxlength="200"  required>
                            </div>
                        </div>
                        

                    
                        <p class="title mt-4 mendate">Discharge Date</p>
                        <div class="sum-insured-input reg-date-input disch_date">
                            <div class="input-group">
                                <div class="input-group addon">
                                    <img
                                        src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/Date.svg">
                                    <p-calendar [touchUI]="true" [readonlyInput]="true" placeholder="Date"
                                        name="dischargeDate" [(ngModel)]="dischargeDate" keepInvalid
                                        dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                                        yearRange="1900:2100" required></p-calendar>
                                    <span class="input-group-addon" id="basic-addon-dueDate"></span>
                                </div>
                            </div>
                        </div>
                     
                        <div class="text-center top-gap-lg mb-4">
                            <div *ngIf="validationError" class="error-message">
                                <div *ngIf="validationError">
                                   {{validationMessage}}
                                </div>
                             
                            </div>
                            <button class="btn btn-bordered-blue"  id="register_btn" 
                                (click)="submitIntimateDetails()">Register Now</button>
                        </div>
                    
                    <div class="col text-center no-found" *ngIf="noDataFound">
                        <!-- <label class="oops-text">Ooops....!</label> -->
                        <img
                            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/no-data-found.jpg">
                        <p>No data found.</p>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="modal fade" id="noRegisterModal" data-keyboard="false" data-backdrop="static">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
            <div class="modal-body claim-pop text-center">
                <div class="claim-icon-sorry">!</div>
                <h6>Sorry</h6>
                <p>We could not find any policy linked with your account.</p>
                <div class="text-center">
                <button type="button" class="btn btn-blue" data-dismiss="modal" routerLink="/home">Ok</button>
                </div>
            </div>
            </div>
        </div>
    </div>
    <div id="spinner" [hidden]="!loading">
        <div class="spinnerfull">
            <i class="fa fa-spinner fa-spin fa-3x"></i>
        </div>
    </div>
</section>
<section class="intimate-successfull" *ngIf="intimateSuccessfull">
    <div class="container">
        <div class="col text-center">
            <h2 class="done-heading">Registration Done</h2>
            <img
                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/done-intimate.jpg">
        </div>
        <center class="sub-title mt-2">
            <p>THANK YOU</p>
        </center>
        <div class="col note text-center">
            <p>We have recieved your claim request. <br> your claim registration no. is <span class="registrationNo">{{this.registrationNumber}}</span>.
            </p>
        </div>
        <div class="col footer-strip text-center">
            <p>For any queries, please reach us at:</p>
            <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
                class="img-responsive" width="40%" alt="Securenow">
            <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span>
            </p>
        </div>
    </div>
</section>
<section class="intimate-successfull" *ngIf="intimateFailure">
    <div class="container">
        <div class="col text-center">
            <h2 class="done-heading">Registration Fail</h2>
            <img
                src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/ERROR.svg">
        </div>
        <center class="sub-title mt-2">
            <p>Error</p>
            <p>{{errorMessage}}</p>
        </center>
        <div class="col note text-center">
            <p>Oops..!! Claim request error. Please try after some time.</p>
        </div>
        <div class="col footer-strip text-center">
            <p>For any queries, please reach us at:</p>
            <img src="https://pamstaging2.securenow.in/static/images/securenow_logo.svg"
                class="img-responsive subnission_image" alt="Securenow">
            <p class="call mt-3"><span>+91 9696683999</span><span class="bar"></span><span>support@securenow.in</span>
            </p>
        </div>
    </div>
</section>